var _defs, _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 238 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:url(#radial-gradient);stroke-width:0px;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 119.22,
    cy: 119.22,
    fx: 119.22,
    fy: 119.22,
    r: 116.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00d80e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#00d50d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00cb0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00bc0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#00a60c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#00890b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007c0b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.22,2.78C54.91,2.78,2.78,54.91,2.78,119.22s52.13,116.44,116.44,116.44,116.44-52.13,116.44-116.44S183.53,2.78,119.22,2.78ZM174.3,198.79l-93.59-53.57-.09.05-45.43-26,.09-.05-.09-.05,45.43-26,.09.05,93.59-53.57v159.14Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.3 198.79 80.71 145.23 80.62 145.28 35.19 119.27 35.28 119.22 35.19 119.17 80.62 93.17 80.71 93.22 174.3 39.65 174.3 198.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.01b83767b162e0e68be0aa9642970f70.svg";
export { ForwardRef as ReactComponent };